import React from 'react';
import { Users, Mail, Download, MessageSquare, TrendingUp, Eye, Ticket, BarChart3, FileDown, Funnel } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const OverviewTab = ({ stats, conversionData, growthData, exportCSV }) => (
  <div className="overview-section" data-testid="overview-enhanced">
    {conversionData?.funnel && (
      <div className="analytics-panel">
        <h3 className="section-heading"><Funnel size={18} /> Conversion Funnel</h3>
        <div className="funnel-container">
          {conversionData.funnel.map((step, i) => {
            const maxCount = conversionData.funnel[0]?.count || 1;
            const width = Math.max((step.count / maxCount) * 100, 12);
            return (
              <div key={i} className="funnel-step">
                <div className="funnel-bar-track">
                  <div className="funnel-bar" style={{ width: `${width}%` }}>
                    <span className="funnel-bar-text">{step.stage}</span>
                  </div>
                </div>
                <div className="funnel-stats">
                  <span className="funnel-count">{step.count}</span>
                  <span className="funnel-rate">{step.rate}%</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    )}

    {growthData?.data?.length > 0 && (
      <div className="analytics-panel">
        <h3 className="section-heading"><TrendingUp size={18} /> Pertumbuhan Subscriber (14 Hari)</h3>
        <div className="daily-chart">
          {growthData.data.map((d, i) => {
            const max = Math.max(...growthData.data.map(v => v.subscribers));
            const height = max > 0 ? (d.subscribers / max) * 100 : 0;
            return (
              <div key={i} className="chart-bar-wrap" title={`${d.date}: ${d.subscribers}`}>
                <div className="chart-bar" style={{ height: `${Math.max(height, 4)}%` }}>
                  <span className="chart-bar-label">{d.subscribers}</span>
                </div>
                <span className="chart-date">{d.date.slice(5)}</span>
              </div>
            );
          })}
        </div>
      </div>
    )}

    <div className="overview-grid">
      <div className="analytics-panel">
        <h3 className="section-heading"><Mail size={18} /> Email Sequence Pipeline</h3>
        <div className="pipeline-container">
          {stats?.email_sequences?.map((seq) => {
            const total = stats?.subscribers?.total || 1;
            const pct = Math.round((seq.count / total) * 100);
            return (
              <div key={seq.stage} className="pipeline-step">
                <div className="pipeline-header">
                  <span className="pipeline-label">{seq.stage === 0 ? 'Welcome' : `Email ${seq.stage}`}</span>
                  <span className="pipeline-count">{seq.count}</span>
                </div>
                <div className="scroll-bar-track">
                  <div className="scroll-bar-fill" style={{ width: `${pct}%` }}></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="analytics-panel">
        <h3 className="section-heading"><Eye size={18} /> Sumber Subscriber</h3>
        <div className="click-list">
          {stats?.sources?.map((source, i) => (
            <div key={source.source} className="click-item">
              <span className="click-rank">{i + 1}</span>
              <span className="click-name">{source.source || 'unknown'}</span>
              <span className="click-count">{source.count}</span>
            </div>
          ))}
        </div>
      </div>
    </div>

    <div className="analytics-panel">
      <h3 className="section-heading"><FileDown size={18} /> Export Data (CSV)</h3>
      <div className="export-grid">
        <button onClick={() => exportCSV('subscribers')} className="export-btn" data-testid="export-subscribers"><Users size={18} /> Subscribers</button>
        <button onClick={() => exportCSV('contacts')} className="export-btn" data-testid="export-contacts"><MessageSquare size={18} /> Contacts</button>
        <button onClick={() => exportCSV('coupons')} className="export-btn" data-testid="export-coupons"><Ticket size={18} /> Kupon</button>
        <button onClick={() => exportCSV('analytics')} className="export-btn" data-testid="export-analytics"><BarChart3 size={18} /> Analytics</button>
      </div>
    </div>
  </div>
);

export default OverviewTab;
